import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import { SettingsItem } from 'design-system/SettingsItem';
import { Spacer } from 'design-system';
import { rem } from 'design-system/values';
import RadioButton from 'design-system/RadioButton';
import { smartRuleTypeLabels } from 'utils/types/navigation';
import { SmartRuleIconForTransactionType } from './SmartRuleIconForTransactionType';
import { isWeb } from '../../../constants';
const listItems = [
    {
        type: 'both',
        title: smartRuleTypeLabels.both,
    },
    {
        type: 'income',
        title: smartRuleTypeLabels.income,
    },
    {
        type: 'spending',
        title: smartRuleTypeLabels.spending,
    },
];
export const SmartRuleTransactionTypeModal = {
    show: ({ onSelect, selected }) => {
        Modal.show(<>
        <Spacer.H16 />
        {listItems.map(({ type, title }) => (<SettingsItem key={type} renderIcon={() => (<RadioButton isChecked={selected === type} type="single" style={styles.radio}/>)} icon={<SmartRuleIconForTransactionType type={type}/>} iconSize={44} title={title} onPress={() => {
                    onSelect(type);
                    Modal.hide();
                }}/>))}
      </>, {
            containerStyle: styles.modal,
            title: 'Transaction type',
        });
    },
};
const styles = StyleSheet.create({
    radio: {
        marginRight: rem(16),
    },
    modal: {
        paddingHorizontal: 0,
        // On web, inset the options so their hover highlight sits inside the modal
        ...(isWeb && { paddingHorizontal: 8, paddingBottom: 8 }),
    },
});
